import { CSSProperties, FC } from 'react';

import { BADGE_PILL_COLOR_COMBINATIONS, BADGE_PILL_SIZES, BadgePillProps } from './BadgePill.shared';

export const BadgePill: FC<BadgePillProps> = ({ leftIcon, onClick, rightIcon, size, testId, text, type }) => {
  const sizeStyles = BADGE_PILL_SIZES[size];
  const colorStyles = BADGE_PILL_COLOR_COMBINATIONS[type];

  const badgePillStyle: CSSProperties = {
    alignItems: 'center',
    backgroundColor: colorStyles.fill,
    borderColor: colorStyles.border,
    borderRadius: '12rem',
    borderStyle: 'solid',
    borderWidth: '0.1rem',
    color: colorStyles.text,
    cursor: onClick ? 'pointer' : 'default',
    display: 'inline-flex',
    fontSize: `${sizeStyles.fontSize / 10}rem`,
    fontWeight: 700,
    gap: leftIcon || rightIcon ? `${sizeStyles.paddingHorizontal / 10}rem` : 0,
    justifyContent: 'center',
    minHeight: `${sizeStyles.minHeight / 10}rem`,
    padding: `0 ${sizeStyles.paddingHorizontal / 10}rem`,
    textTransform: 'uppercase',
    textWrapMode: 'nowrap',
  };

  const badgePillContentStyle = {
    alignItems: 'center',
    display: 'inline-flex',
    lineHeight: `${sizeStyles.contentHeight / 10}rem`,
    minHeight: `${sizeStyles.contentHeight / 10}rem`,
  };

  return (
    <div data-test={testId} onClick={onClick} role="button" style={badgePillStyle}>
      <div style={badgePillContentStyle}>{leftIcon}</div>
      <div style={badgePillContentStyle}>{text}</div>
      <div style={badgePillContentStyle}>{rightIcon}</div>
    </div>
  );
};
